import { RouteConfig } from 'vue-router';
import { EditorRoute } from '/@/modules/export/_modules/editor/routes/EditorRoute';

export const router: RouteConfig[] = [
  {
    path: `/editor/:id?`,
    name: 'editor',
    component: () => import('/@/modules/export/_modules/editor/pages/EditorTemplateEditorPage.vue')
  },
  {
    path: EditorRoute.EDITOR_DOCUMENT.path,
    name: EditorRoute.EDITOR_DOCUMENT.name,
    component: () =>
      import('/@/modules/export/_modules/editor/pages/EditorTemplateDocumentEditorPage.vue')
  }
];
